<script>
    export default {
        created() {
            this.onlySelected = this.params['onlySelected'];
        },
        data() {
            return {
                params: URI(window.location.href).search(true),
                url: new URL(location.href),
                onlySelected: null,
            }
        },
        methods: {
            valueChanged() {
                this.applyFilter(this.onlySelected);
            },
            applyFilter(selectedItem) {
                if (selectedItem) {
                    this.params['onlySelected'] = selectedItem;
                } else {
                    delete this.params['onlySelected'];
                }

                window.location.href = URI(window.location.href).search(this.params).href();
            },
        }
    }
</script>

<template>
    <div id="pr-filter-only-selected">
        <label>
            <input type="checkbox"
                   v-model="onlySelected"
                   @change="valueChanged"
                   true-value="1"
                   false-value="">
            <i class="fa fa-shopping-cart" aria-hidden="true"></i>
            <span v-text="__('scoop-pr.general.only_selected')"></span>
        </label>
    </div>
</template>
